import { useEffect, useState } from "react";
import { getUsers, activateUser, deactivateUser, changePlan } from "../services/api";

export default function Admin() {
  const [users, setUsers] = useState([]);

  const loadUsers = async () => {
    const res = await getUsers();
    setUsers(res.data);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleActivate = async (id) => {
    await activateUser(id);
    loadUsers();
  };

  const handleDeactivate = async (id) => {
    await deactivateUser(id);
    loadUsers();
  };

  const handlePlan = async (id, plan) => {
    await changePlan(id, plan);
    loadUsers();
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Admin Dashboard</h2>

      <table className="w-full bg-white shadow rounded">
        <thead>
          <tr className="bg-gray-200">
            <th>Email</th>
            <th>Plan</th>
            <th>Usage</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {users.map((u) => (
            <tr key={u.id} className="border-t text-center">
              <td>{u.email}</td>
              <td>{u.plan}</td>
              <td>{u.usage}</td>
              <td>{u.is_active ? "Active" : "Inactive"}</td>

              <td className="space-x-2">
                <button onClick={() => handleActivate(u.id)} className="bg-green-500 text-white px-2 py-1">
                  Activate
                </button>

                <button onClick={() => handleDeactivate(u.id)} className="bg-red-500 text-white px-2 py-1">
                  Deactivate
                </button>

                <button onClick={() => handlePlan(u.id, "pro")} className="bg-blue-500 text-white px-2 py-1">
                  Pro
                </button>

                <button onClick={() => handlePlan(u.id, "free")} className="bg-gray-500 text-white px-2 py-1">
                  Free
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}